export const SHIPMENT_CONSTANTS = {
    PACKAGES_STATUS_PAGE_SIZE: 10,
    DELIVERED_TO_SENDER_DOWNLOAD_FILE: ':api/admin/customers/with-returned/',
};
